import { useCallback, useEffect, useRef, useState } from 'react'

import { axiosInstance } from '../../../../../hooks/useAxios'
import { ICostBackfillStatus } from '../types'

const POLL_MS = 5000

// สถานะ backfill ต้นทุนของร้าน — โหลดตอน mount แล้ว poll ต่อเฉพาะตอนที่ยังรันอยู่
// (ทนต่อการ refresh หน้า ต่างจาก socket ที่พลาดถ้าปิดแท็บ)
// onFinished ยิงตอนสถานะเปลี่ยนจาก IN_PROGRESS → จบ เพื่อให้ผู้เรียกโหลดตารางใหม่
export const useCostBackfillStatus = (onFinished?: () => void) => {
  const [status, setStatus] = useState<ICostBackfillStatus | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const wasRunning = useRef<boolean>(false)
  const finishedRef = useRef(onFinished)
  finishedRef.current = onFinished

  const fetchStatus = useCallback(async () => {
    try {
      const res = await axiosInstance.get<ICostBackfillStatus>(
        '/tiktok/backfill-cost/status',
      )
      setStatus(res.data)
      if (wasRunning.current && res.data?.status !== 'IN_PROGRESS') {
        finishedRef.current?.()
      }
      wasRunning.current = res.data?.status === 'IN_PROGRESS'
    } catch {
      // สถานะเป็นข้อมูลเสริม — ล้มก็ไม่ต้องขึ้น error ทับหน้าจอ
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchStatus()
  }, [fetchStatus])

  // poll ต่อเมื่อมีงานวิ่งอยู่เท่านั้น — จบแล้วหยุดยิง
  useEffect(() => {
    if (status?.status !== 'IN_PROGRESS') {
      return
    }
    const timer = setInterval(fetchStatus, POLL_MS)
    return () => clearInterval(timer)
  }, [status?.status, fetchStatus])

  return {
    status,
    isLoading,
    isRunning: status?.status === 'IN_PROGRESS',
    pending: status?.pending ?? 0,
    refetch: fetchStatus,
  }
}
